import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import formatData from "../utils/formatData";

const getRewardRedemptions = async function(rewardId = null) {
    const db = firebase.firestore();
    const redemptionsList = [];

    if(rewardId){
        const query = db.collection('wellness_rewards/' + rewardId + '/redeem_history');
        const redemptionsSnapshot = await query.get();
        const redemptions = redemptionsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        redemptions.forEach(async redemption => {
            if (redemption.redeemedDate && typeof redemption.redeemedDate.toDate === 'function') {
                redemption.redeemedDate = formatData('datepicker', redemption.redeemedDate.toDate());
            }
           
            redemptionsList.push({
                ...redemption
            });
        });
    }else{
        const redemptionQuery = db.collectionGroup('redeem_history');
        const redemptionsSnapshot = await redemptionQuery.get();
        const redemptions = redemptionsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        redemptions.forEach(async redemption => {
            if (redemption.redeemedDate && typeof redemption.redeemedDate.toDate === 'function') {
                redemption.redeemedDate = formatData('datepicker', redemption.redeemedDate.toDate());
            }
            if (redemption.paidDate && typeof redemption.paidDate.toDate === 'function') {
                redemption.paidDate = formatData('datetime', redemption.paidDate.toDate());
            }
            redemption.image = redemption.rewardImage;
            redemptionsList.push({
                ...redemption
            });
        });
    }
    return redemptionsList;
};

export default getRewardRedemptions; 